export default __webpack_public_path__ + "static/media/truck.dd17d905.svg";